import { useLocation } from "react-router-dom";

export default function useQueryParams() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  return query;
  
}
